import { render, staticRenderFns } from "./ProductSliderWGrid.vue?vue&type=template&id=4c20708e&scoped=true&"
import script from "./ProductSliderWGrid.vue?vue&type=script&lang=js&"
export * from "./ProductSliderWGrid.vue?vue&type=script&lang=js&"
import style0 from "./ProductSliderWGrid.vue?vue&type=style&index=0&id=4c20708e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c20708e",
  null
  
)

export default component.exports